// Shared formatter for OT-related hour displays (Hours This Week cell and
// the OT risk banner). Renders with up to 2 decimals so quarter-hour
// totals (45.25, 42.75) survive the trip from the OT calculation to the
// UI without being rounded down to the nearest tenth. Trailing zeros in
// the decimal portion are stripped — 45.5 stays "45.5" (not "45.50") and
// whole hours stay integer ("40", not "40.00"). Centralising the format
// keeps the cell and banner visually consistent by construction.
export const formatHours = (n: number): string => {
  if (!Number.isFinite(n)) return '0';
  // Round to 2 decimals before formatting so JS float drift (e.g.
  // 0.1 + 0.2 = 0.30000000000000004) doesn't leak into the UI.
  const rounded = Math.round(n * 100) / 100;
  if (Number.isInteger(rounded)) return String(rounded);
  return rounded.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
};

export default formatHours;
